/**
 * W07: 강의에 저장된 조건과 분리한 이번 검색의 조건. 관리 화면과 같은 편집 부품을 사용한다.
 * 화면 글자에 「원본」을 쓰지 않는다(오너 2026-09-13) — 되돌리기 버튼은 강의 작업 칸과 같은 [조건 되돌리기].
 */
import { useState } from 'react';
import { RotateCcw } from 'lucide-react';
import { Button } from '../common';
import QuickConditions from '../SyllabusV2/QuickConditions';
import QueryEditor from '../SyllabusV2/QueryEditor';
import { inspectExpr } from '../SyllabusV2/syllabusQuery';
import { exprKey } from '../SyllabusV2/workspaceModel';
import { MathPath } from '../SyllabusV2/MathName';

export default function SyllabusComposeConditions({ pick, query, onChange, onApplySearch, onRevert, onChoose, onClear, dict, labelNames, onRememberLabels, searching }) {
  const [group, setGroup] = useState(0);
  const [detail, setDetail] = useState(false);
  const valid = query != null && inspectExpr(query, { mode: 'search' });
  const dirty = exprKey(query) !== exprKey(pick.query);
  return (
    <div className="space-y-2 rounded-xl border border-primary/30 bg-white p-2.5" aria-label="이번 검색의 강의 조건">
      <div className="flex flex-wrap items-center gap-1.5 text-xs text-gray-700">
        <strong className="min-w-0 flex-1" title={pick.path.join(' › ')}><MathPath names={pick.path} /></strong>
        <Button size="xs" variant="secondary" onClick={onChoose}>다른 줄</Button>
        <Button size="xs" variant="ghost" onClick={onClear}>강의 해제</Button>
      </div>
      <p className="text-[11px] text-gray-500">이번 검색에만 적용됩니다. 강의에 저장된 조건은 바뀌지 않습니다.</p>
      <QuickConditions query={query} onChange={onChange} onApplySearch={onApplySearch} groupIndex={group} onGroupChange={setGroup} dict={dict} labelNames={labelNames} onRememberLabels={onRememberLabels} onOpenDetail={() => setDetail(true)} onToggleDetail={() => setDetail((v) => !v)} detailOpen={detail} detailIconOnly />
      {/* ↑ [상세 조건] 버튼은 여닫기, 「그 밖」 칩·중복 경고 링크는 열기만 — 강의 작업 칸(WorkPanel)과 같게(2026-09-14).
          여기서만 아이콘만 — 검색 열이 좁아 글자까지 두면 난이도 줄이 두 줄이 된다(오너 2026-09-14) */}
      {detail && (
        <div className="space-y-2 border-t border-gray-100 pt-2">
          <QueryEditor value={query} onChange={onChange} dict={dict} labelNames={labelNames} onRememberLabels={onRememberLabels} activeGroup={group} onActiveGroupChange={setGroup} />
          <Button size="xs" variant="secondary" onClick={() => setDetail(false)}>상세 조건 닫기</Button>
        </div>
      )}
      {valid && !valid.ok && <p role="alert" className="text-xs text-red-600">{valid.error.message}</p>}
      <div className="flex flex-wrap items-center justify-end gap-1.5">
        {dirty && <span className="mr-auto text-[11px] font-medium text-amber-700">이번 검색 조건 변경됨</span>}
        <Button size="xs" variant="secondary" onClick={onRevert} disabled={!dirty} title="이번 검색의 변경을 버리고 강의에 저장된 조건으로 되돌립니다"><RotateCcw aria-hidden="true" className="mr-1 size-3" />조건 되돌리기</Button>
        <Button size="xs" onClick={() => onApplySearch(query)} disabled={!valid?.ok || searching} loading={searching}>문제 검색</Button>
      </div>
    </div>
  );
}
